<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>


<p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)" *ngIf="!carInformacionInicial">
  <p-accordionTab header="{{'PLAGA.LBL_CREAPLAGA'|translate}}" [selected]="tabSeleccionado === 'PLAGA'">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idForm" name="nomForm">

          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>{{'LBL_CODIGO' | translate}}:</label>
                <input type="text" pInputText id="codigo"
                       name="nomCodigo"
                       autocomplete="off"
                       formControlName="codigo"
                       codigos-reactive
                       [maxLength]="10"
                       *ngIf="!plaga"
                >
                <label class="falso-combo-texto" *ngIf="plaga">{{ plaga.codigo }}</label>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                  {{ 'LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>{{'PLAGA.LBL_NOMPLAGA' | translate}}:</label>
                <input type="text" pInputText id="nombre"
                       name="nomNombre"
                       autocomplete="off"
                       formControlName="nombre"
                       capitalize-reactive
                       [maxLength]="100"
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                  {{ 'PLAGA.LBL_NOMPLAGA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>

          <div class="grid form-group">
            <div class="col-12 md:col-4 lg:col-4 md:col-offset-5 lg:col-offset-5">
              <div class="div-form">
                <p-checkbox formControlName="indicadorHabilitado" binary="true"></p-checkbox>
                <label>{{'LBL_HABILITADO' | translate}}</label>
              </div>
            </div>
          </div>

          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                        type="submit"
                        pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  </p-accordionTab>
  <p-accordionTab header="{{'PLAGA.LBL_RELPROCOM'|translate}}" [selected]="tabSeleccionado === 'PRODCOME'"
                  [disabled]="!plaga"
                  *ngIf="plaga && plaga.idPlaga">
    <app-plaga-producto-comercial [plaga]="plaga"></app-plaga-producto-comercial>
  </p-accordionTab>
  <p-accordionTab header="{{'PLAGA.LBL_RELPRO'|translate}}" [selected]="tabSeleccionado === 'PRODUCTO'"
                  [disabled]="!plaga"
                  *ngIf="plaga && plaga.idPlaga">
    <app-plaga-producto [plaga]="plaga"></app-plaga-producto>
  </p-accordionTab>
</p-accordion>

<div class="grid form-footer-buttons">
  <div class="form-group col-12">
    <div>
      <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
              type="button" (click)="regresar(false)"
              pButton></button>
    </div>
  </div>
</div>

<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
